import { SidenavSection } from "../../parts/sidenav-nav.model";

/**
 * Contract Admin menu, rendered by `app-sidenav-group` inside the home view.
 * Includes catalogs, contract reports, and contracts management.
 */
export const CONTRACT_ADMIN_SECTIONS: SidenavSection[] = [
    {
        id: "contract-management",
        items: [
            { labelKey: "ADMIN.CONTRACT_ADMIN.CONTRACTS", icon: "file-edit", segments: ["contract-admin", "contracts"] },
            { labelKey: "ADMIN.CONTRACT_ADMIN.CATALOGS", icon: "box", segments: ["contract-admin", "catalogs"] },
            { labelKey: "ADMIN.CONTRACT_ADMIN.DATASETS", icon: "database", segments: ["contract-admin", "datasets"] },
            { labelKey: "ADMIN.CONTRACT_ADMIN.REPORTS", icon: "chart-bar", segments: ["contract-admin", "reports"] },
        ],
    },
];
